// extracted by mini-css-extract-plugin
export default {"movie":"MovieSlide_movie__Xiwg5","letters":"MovieSlide_letters__NqT94","title":"MovieSlide_title__G5cbB","movieName":"MovieSlide_movieName__VKCOY"};